<template>

    <div :class="['picContainer', type]">

        <vue-dropzone
            ref="vueDropzone"
            id="vueDropzone"
            url= "fileProcessing/upload?preset=equipmentCatalog"
            :thumbnailWidth="145"
            :thumbnailHeight="67"
            :maxFiles="1"
            acceptedFiles= ".jpg,.jpeg,.png,.pdf"
            :dictDefaultMessage="`<i class='fa fa-cloud-upload'></i>`+dropzoneDefaultMessage"
            v-on:vdropzone-removed-file="dzRemove"
            v-on:vdropzone-mounted="dzInit"
            v-on:vdropzone-success="dzSuccess"
            dzClass="dzSingle">
        </vue-dropzone>

        <!--
        <template v-if="element.asset">

            <div class="imageContainer lazy-img-fadein" v-lazy:background-image="imageAsset">

            </div>

        </template>


        <template v-else>

            <vue-dropzone
                ref="vueDropzone"
                id="vueDropzone"
                url= "fileProcessing/upload?preset=equipmentCatalog"
                :thumbnailWidth="145"
                :thumbnailHeight="67"
                :maxFiles="1"
                acceptedFiles= ".jpg,.jpeg,.png,.pdf"
                :dictDefaultMessage="`<i class='fa fa-cloud-upload'></i>`+dropzoneDefaultMessage"
                v-on:vdropzone-removed-file="dzRemove"
                v-on:vdropzone-mounted="dzInit"
                v-on:vdropzone-success="dzSuccess"
                dzClass="dzSingle">
            </vue-dropzone>

        </template>
        -->

    </div>

</template>


<script>
import vue2Dropzone from '../utils/dropzoneWrapper';


export default {

    name: 'catalogPageElementPicture',

    props: {
        element: {
            type: Object,
            required: true,
            default: function() { return {} }
        },
        elements: {
            type: Array,
            required: true,
            default: function() { return [] }
        },
        elementIndex: {
            type: Number,
            required: true,
            default: 0
        },
        type: {
            type: String,
            required: false,
            default: null
        }

    },

    components: {
		vueDropzone: vue2Dropzone
    },


    computed: {

        imageAsset() {

            let fileExt = this.element.asset.filename.split('.').pop();

            if(fileExt == 'pdf') {

                let filename = this.element.asset.filename.substr(0, this.element.asset.filename.lastIndexOf(".")) + ".jpg";
                return this.$config.assets + this.element.asset.path + '/thumb/' + filename;

            } else {

                return this.$config.assets + this.element.asset.path + '/' + this.element.asset.filename;

            }

        },

        dropzoneDefaultMessage() {

            if(this.type != null && this.type == "INTRO_PAGE") {
                return 'Bild hochladen';
            }

            return this.element.type && this.element.type.name == 'BANNER' ? 'Banner hochladen' : 'Bild hochladen';

        }

    },

	data() {

		return {
            categories: [],
            isLoaded: false
        }

    },

    created() {


    },

    mounted() {


    },

    updated() {


    },


    methods: {

        dzInit() {

            if(this.element.asset) {

				var filename = this.element.asset.filename.split('.').pop() == 'pdf'
					? this.element.asset.filename.substr(0, this.element.asset.filename.lastIndexOf(".")) + ".jpg"
					: this.element.asset.filename;

                // set the url
                // let url = this.$config.assets + this.element.asset.path + '/thumb/' + filename;
                var mockFile = { id: 'ecCover', name: filename, type: "image/*", size: 123 }

                let url = this.imageAsset;

                // add mockFile to our dropzone
                this.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

            }

		},

		dzSuccess(file) {

            this.$refs.vueDropzone.$children[0].removeAllFiles();

			var result = JSON.parse(file.xhr.response);

            this.element.asset = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			// set the url
			let filename = this.element.asset.filename.substr(0, this.element.asset.filename.lastIndexOf(".")) + ".jpg"
			// let url = this.$config.assets + this.element.asset.path + '/thumb/' + filename;
            let url = this.imageAsset;
			let mockFile = { id: 'ecCover', name: filename, type: "image/*", size: 123 }

			// add mockFile to our dropzone
			this.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

            // this.saveCatalog( { isSilent: true } );

		},

		dzRemove(file, error, xhr) {

			if(typeof file === 'undefined') {
				return;
			}

            this.element.asset = null;

            // this.saveCatalog( { isSilent: true } );

		}


    }

}
</script>



<style scoped>

    .imageContainer {
        width: 100%;
        height: auto;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: cover;
    }

    /* BANNER */
    .BANNER .vue-dropzone,
    .BANNER .imageContainer {
        height: 170px;
    }
    .BANNER .imageContainer.lazy-img-fadein[lazy=loading] {
        background-size: 10% !important;
    }

    /* FULLSIZE */
    .FULLSIZE_AD .vue-dropzone,
    .FULLSIZE_AD .imageContainer {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
    }

    /* INTRO PAGE */
    .INTRO_PAGE {
        position: absolute;
        top: 150px;
        bottom: 150px;
        left: 0;
        right: 300px;
    }
    .INTRO_PAGE .vue-dropzone,
    .INTRO_PAGE .imageContainer {
        height: 100%;
    }

    .picContainer >>> .dz-image img {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
    }
    .picContainer >>> .customdropzone.dzSingle .dz-preview  {
        width: 100% !important;
        height: 100% !important;
        margin: 0 !important;
    }
</style>
